<template>
  <div module-item :class="info.type">
    <ul>
      <li v-for="row in info.value" :key="row">
        <cdn-img :src="row" v-if="matchMediaType(row, 'image')"/>
        <cdn-video :src="row" loop autoplay muted playsinline v-if="matchMediaType(row, 'video')"/>
      </li>
    </ul>
  </div>
</template>

<script>

import CdnImg from '@/views/components/CdnImg.vue';
import CdnVideo from '@/views/components/CdnVideo.vue';

export default {
  name: 'TripleMedia',
  components: { CdnVideo, CdnImg },
  props: ['value'],
  computed: {
    info() {
      return this.value;
    },
  },
};
</script>

